import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {COMMITMENT_LETTER_STATUS, contractColorsCodes, CONTRACT_STATUS, statusObjects} from '../../utils/contracts';

const StatusWrapper = styled.div`
  
`;

const ContractStatus = props => {
    const {status, role, statusMessage} = props;
    const state = (statusObjects[status] && statusObjects[status][role]) ||
        statusObjects[status] ||
        {message: status, color: contractColorsCodes.Neutral}; // Fallback

    let message = 'Active'; // default status message
    let style = {};

    if (state) {
        message = state.message;
        style = {...state};
    }

    return <StatusWrapper style={{...style}}>{statusMessage || message}</StatusWrapper>;
};

ContractStatus.propTypes = {
    status: PropTypes.string.isRequired,
    statusMessage: PropTypes.string,
    role: PropTypes.string.isRequired
};

ContractStatus.defaultProps = {
    status: '',
    role: ''
};

export default ContractStatus;
